<section>
    <div class="wrapper">
        <article class="mrt-75">
            <div class="footage-queue-component">
                <mat-grid-list cols="3" rowHeight="45px" class="header-grid">
                    <mat-grid-tile>
                        <span class="header">Download Footage</span>
                    </mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                </mat-grid-list>
            </div>
            <div class="footage-queue-table">
                <div class="mat-elevation-z8 table-pagination">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
                        (matSortChange)="sortData($event)" matSortActive="ui_created_date" matSortDisableClear
                        matSortDirection="desc">

                        <!-- Id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Potential ID </th>
                            <td mat-cell *matCellDef="let element"> {{element?.potential_id}} </td>
                        </ng-container>

                        <!-- Footage queue name Column -->
                        <ng-container matColumnDef="potentialName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                            <td mat-cell *matCellDef="let element">{{element?.site_name}} </td>
                        </ng-container>

                        <!-- Cam name Column -->
                        <ng-container matColumnDef="cam_name">
                            <th mat-header-cell *matHeaderCellDef> Camera Name </th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="element?.cam_name">
                                <div class="status-cell">
                                    {{(element?.cam_name === null || element?.cam_name === "") ? '-' :
                                    element?.cam_name }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                            <td mat-cell *matCellDef="let element" [matTooltip]="element?.status">
                                <div class="status-cell">
                                    {{element?.status}}
                                </div>
                            </td>
                        </ng-container>

                        <!-- Created Column -->
                        <ng-container matColumnDef="ui_created_date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="created-at-cell">
                                    {{element?.ui_created_date | date:'dd-MMM-yyyy HH:mm'}}
                                </div>
                            </td>
                        </ng-container>

                        <!-- Date Range Column -->
                        <ng-container matColumnDef="date_range">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Range </th>
                            <td mat-cell *matCellDef="let element">
                                <div>
                                    <span>{{element?.ui_from_date | date:'dd-MMM-yyyy HH:mm'}} - </span>
                                    <span>{{element?.ui_to_date | date:'dd-MMM-yyyy HH:mm'}}</span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="reported_by">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested </th>
                            <td mat-cell *matCellDef="let element">{{element?.user_name}}</td>
                        </ng-container>
                        <ng-container matColumnDef="size">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Size </th>
                            <td mat-cell *matCellDef="let element">
                                <!-- <span>{{ dateRangeDiff(element.from_date, element.to_date) }}</span> -->
                                <span>{{element?.file_size}}</span>
                            </td>
                        </ng-container>


                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-btn">
                                    <a href="{{element?.s3_url}}" mat-raised-button color="primary"
                                        *ngIf="element.status == 'COMPLETED'" class="edit-btn" style="margin-left: 5px;"
                                        matTooltip="Footage download">
                                        <mat-icon aria-hidden="false"
                                            aria-label="Footage download">cloud_download</mat-icon>
                                    </a>
                                    <button mat-raised-button color="primary" *ngIf="element.status == 'COMPLETED'"
                                        class="edit-btn" style="margin-left: 3px;" (click)="copyURL(element?.s3_url)"
                                        matTooltip="Copy Url">
                                        <mat-icon aria-hidden="false"
                                            aria-label="Footage download">content_copy</mat-icon>
                                    </button>
                                    <button mat-raised-button color="primary" *ngIf="element.status == 'QUEUED'"
                                        class="cancel-footage-btn" style="margin-left: 3px;" (click)="cancelFootage(element?.process_id)"
                                        matTooltip="Cancel the footage">
                                        <mat-icon aria-hidden="false"
                                            aria-label="Cancel Footage">cancel</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>
                    <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
                        No Records Found!
                    </div>
                    <mat-paginator #paginator class="hide-ripple" [pageSizeOptions]="[10, 25, 50, 100]"
                        [pageSize]="pageSize" [length]="totalRecords" [pageIndex]="pageNumber"
                        (page)="changePaging($event)" aria-label="Select page of users">
                    </mat-paginator>
                </div>
            </div>
        </article>
    </div>
</section>